import { render, staticRenderFns } from "./creatSuccess.vue?vue&type=template&id=3c4f736c&"
import script from "./creatSuccess.vue?vue&type=script&lang=js&"
export * from "./creatSuccess.vue?vue&type=script&lang=js&"
import style0 from "./creatSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports